import { createStore } from 'store-utils';

const downloadPBOMStore = createStore<PBOMStore>(
  {
    totalSentCount: 0,
    totalReturnedCount: 0,
    downloadInProgress: false,
    totalErrored: 0,
  },
  'Download PBOM store',
);

export default downloadPBOMStore;

interface PBOMStore {
  totalSentCount: number;
  totalReturnedCount: number;
  downloadInProgress: boolean;
  totalErrored: number;
}
